import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({ name: "GlobalBikeItemImages" })
export default class GlobalBikeItemImages extends Vue {
    @Prop() readonly bremboCode: string;
    @Prop() readonly productImages: any[];

    @Watch("productImages") onProductImagesChanges() {
        if (this.productImages && this.productImages.length !== 0) {
            this.$nextTick(function () {
                this.setGallery();
            });
        }
    }

    public mounted() {
        if (this.productImages && this.productImages.length !== 0) {
            this.$nextTick(function () {
                this.setGallery();
            });
        }
    }

    public checkProductImage(): boolean {
        return this.productImages?.some(item => item.bremboCode === this.bremboCode && (item.type === "Product_1" || item.type === "Product_2" || item.type === "Product_3"));
    }

    public getProductImage(type: string): string {
        const image = this.productImages?.find(item => item.bremboCode === this.bremboCode && item.type === type);
        return image && image.imageUrl ? image.imageUrl : "";
    }

    public getProductImageZoom(type: string): string {
        const image = this.productImages?.find(item => item.bremboCode === this.bremboCode && item.type === type);
        return image && image.imageZoomUrl ? image.imageZoomUrl : "";
    }

    public setGallery() {
        let carosel = document.getElementById("Carousel_" + this.bremboCode);
        if (carosel) {
            new (<any>window).Carousel(carosel, {
                infinite: false,
                Dots: false,
                transition: "slide"
            });
        }

        (<any>window).Fancybox.bind("[data-fancybox='gallery " + this.bremboCode + "']", {
            dragToClose: false,
            Images: {
                zoom: true,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });

        (<any>window).Fancybox.bind("[data-fancybox]", {});
    }
}